import React from 'react';
import styled from 'styled-components';
import Asterisk from '../../inputs/Asterisk';

interface Props {
	isTimePage?: boolean;
}

const RequiredLabelWrapper = styled.div<Props>`
	display: flex;
	align-items: center;
	margin-bottom: ${p => (p.isTimePage ? null : '2px')};
	height: 11px;

	line-height: ${p => (p.isTimePage ? null : '0')};
`;

type LabelWithTooltipProps = {
	label: string;
	isRequired?: boolean;
	alwaysShowTooltip?: boolean;
	children: JSX.Element;
	isTimePage?: boolean;
};

function LabelWithTooltip({label, isRequired, alwaysShowTooltip, children, isTimePage}: LabelWithTooltipProps): JSX.Element {
	return (
		<RequiredLabelWrapper isTimePage={isTimePage}>
			<div style={{marginTop: isTimePage ? '0' : '2px'}}>{label}</div>
			{isRequired ? <Asterisk /> : null}
			{isRequired || alwaysShowTooltip ? <div style={{marginLeft: '4px'}}>{children}</div> : null}
		</RequiredLabelWrapper>
	);
}

export default LabelWithTooltip;
